import {
  useAccount,
  useHasEntitlement,
  useIsAdmin,
} from '~publish/contexts/AccountContext'

interface UseCanAccessTeamFeaturesReturn {
  canAccessTeamFeatures: boolean
  isLoading: boolean
}

export const useCanAccessTeamFeatures = (): UseCanAccessTeamFeaturesReturn => {
  const { account } = useAccount()
  const isAdmin = useIsAdmin()
  const hasAccessTeamPanel = useHasEntitlement('teamsPanel')
  const canAccessTeamFeatures = hasAccessTeamPanel && isAdmin
  const isLoading = !account

  return {
    canAccessTeamFeatures,
    isLoading,
  }
}
